/* eslint react/prefer-stateless-function: 0 */
// react
import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";

export default class TaskRunnerPortal extends React.Component {
	static propTypes = {
		className: PropTypes.string,
		children: PropTypes.node.isRequired,
		selector: PropTypes.string.isRequired,
	};

	static defaultProps = {
		className: "",
	};

	render() {
		const { className, children, selector } = this.props;

		const portalMount = document.getElementById(selector);

		if (!portalMount) {
			return null;
		}

		return ReactDOM.createPortal(<div className={`task-runner-wrapper ${className}`}>{children}</div>, portalMount);
	}
}
